<template>
  <div>
    <MasterLayout>
      <div class="text-center page-header-heading pt-5 pb-4">
        <div class="center-card position-relative">
          <div class="top-header"></div>
          <div class="d-flex align-items-center justify-content-between h-100">
            <div class="pr-5 mr-2" v-show="toggle" @click="toggle = !toggle">
              <i
                class="fa fa-arrow-circle-left w-25 primary-color fa-icon cursor-pointer pr-5 mr-5"
                aria-hidden="true"
              ></i>
            </div>
            <div class="">
              <p class="text-center m-0 page-header">
                {{ $t("text.vehicles.generateVehicleVoucher") }}
              </p>
            </div>
            <div
              class="vouchers_submit ml-5"
              v-show="toggle"
              @click="toggle = !toggle"
            >
              <div class="vehicle_voucher_btns_div_1 mt-0 ml-4">
                <button
                  class="ep-btn ep-primary border-0 rounded"
                  @click="sendVoucherToVehicles($event, 'send')"
                  :disabled="isButtonDisabled ? true : null"
                  :style="[
                    isButtonDisabled
                      ? { cursor: 'not-allowed' }
                      : { cursor: 'pointer' },
                  ]"
                >
                  {{ $t("text.vehicles.createVoucher") }}
                </button>
                <img
                  src="@/assets/img/git_loader.gif"
                  style="display: none"
                  width="35px"
                  class="ml-3 loader"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <section class="center-card--body pb-3 mt-3" v-show="!toggle">
        <h6 class="center-card--header text-center py-3">
          {{ $t("text.vehicles.enterDetails") }}
        </h6>
        <div class="Add_driver_form" style="width: 80%; margin: 0 auto">
          <div class="form_input_section">
            <label for="amount">{{ $t("text.vehicles.amount") }}</label>
            <div class="input__block" ref="plate_input_div">
              <input
                id="amount"
                type="text"
                placeholder="Amount"
                class="form-control input_full_width"
                v-model="amount"
                required
              />
            </div>
            <div ref="plate_error_template"></div>
          </div>
          <div class="form_input_section mt-3">
            <label for="">{{ $t("text.vehicles.returnBalance") }}</label>
            <div class="input__block" ref="balance_to_input_div">
              <select v-model="returnBalanceTo">
                <option value="Wallet">{{ $t("text.vehicles.wallet") }}</option>
                <option value="Bearer">{{ $t("text.vehicles.bearer") }}</option>
              </select>
            </div>
            <div ref="email_error_message"></div>
          </div>
          <div class="form_input_section mt-3">
            <label for="validity">{{ $t("text.vehicles.validity") }}</label>
            <div class="input__block" ref="balance_to_input_div">
              <select v-model="validity" id="validity">
                <option value="6 Hours">
                  {{ $t("text.vehicles.sixHours") }}
                </option>
                <option value="12 Hours">
                  {{ $t("text.vehicles.twelveHours") }}
                </option>
                <option value="24 Hours">
                  {{ $t("text.vehicles.twentyFourHours") }}
                </option>
                <option value="7 Days">
                  {{ $t("text.vehicles.sevenDays") }}
                </option>
                <option value="30 Days">
                  {{ $t("text.vehicles.thirtyDays") }}
                </option>
                <option value="Never">{{ $t("text.vehicles.never") }}</option>
              </select>
            </div>
            <div ref="email_error_message"></div>
          </div>
          <div class="form_input_section mt-3">
            <label for="used">{{ $t("text.vehicles.used") }}</label>
            <div class="input__block" ref="balance_to_input_div">
              <select v-model="canBeUsedIn" id="used">
                <option value="All">{{ $t("text.vehicles.all") }}</option>
                <option
                  v-show="retainerships"
                  v-for="(retainership, index) in retainerships"
                  :key="index"
                >
                  {{ retainership.company }}
                </option>
              </select>
            </div>
            <div ref="email_error_message"></div>
          </div>
          <div class="text-center mt-4">
            <button
              class="ep-btn ep-primary"
              @click="toggleVehicle($event)"
              :disabled="isButtonDisabled ? true : null"
              style="border: 0"
              :style="[
                isButtonDisabled
                  ? { cursor: 'not-allowed' }
                  : { cursor: 'pointer' },
              ]"
            >
              {{ $t("text.vehicles.selectVehicle") }}<span></span>
            </button>
            <img
              src="@/assets/img/git_loader.gif"
              style="display: none"
              width="35px"
              class="ml-3 loader"
            />
          </div>
        </div>
      </section>

      <section class="center-card--body pb-3 mt-4" v-show="toggle">
        <ejs-grid
          v-show="!showLoader"
          ref="dataGrid"
          :created="refreshGrid"
          :allowPaging="true"
          :allowSorting="true"
          :pageSettings="pageSettings"
          :toolbar="toolbar"
          :searchSettings="search"
          :allowExcelExport="true"
          :allowPdfExport="true"
          :toolbarClick="toolbarClick"
          :queryCellInfo="queryCellInfoEvent"
          :pdfQueryCellInfo="pdfQueryCellInfo"
          :allowTextWrap="true"
          :rowDataBound="rowDataBound"
          :locale="usedLang"
        >
          <e-columns>
            <e-column
              field="index"
              width="50"
              :template="checkBoxTemplate"
              :headerTemplate="selectAllTemplate"
              headerText="#"
            ></e-column>
            <e-column
              width="120"
              field="plateNumber"
              :headerText="$t('text.vehicles.plateNumber')"
            ></e-column>
            <e-column
              width="150"
              field="phoneNo"
              :headerText="$t('text.vehicles.phoneNumber')"
            ></e-column>
            <e-column
              width="150"
              field="driver"
              :headerText="$t('text.vehicles.driver')"
            ></e-column>
            <!-- <e-column
                      field="userId"
                      width="200"
                      :visible="false"
                    ></e-column> -->
          </e-columns>
        </ejs-grid>
        <TableLoader :showLoader="showLoader" />
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Customer/MasterLayout.vue";
import backgroundUrl from "@/assets/img/danskebank.jpg";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import VehiclesTemp from "@/components/Templates/vehiclesTemp";
import { Page, Sort, Toolbar, Search } from "@syncfusion/ej2-vue-grids";
import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Generate Voucher:: Epump Portal",
  name: "DashboardHome",
  components: {
    MasterLayout,
    TableLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      backgroundUrl,
      amount: "",
      returnBalanceTo: "Wallet",
      validity: "6 Hours",
      validityValue: "",
      vehicleCount: 0,
      allCount: 0,
      canBeUsedIn: "All",
      mode: null,
      checked: [],
      retainerships: null,
      vehiclesArray: [],
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["Search"],
      search: { operator: "contains", ignoreCase: true },
      showLoader: false,
      vehiclesCount: 0,
      toggle: false,
      isButtonDisabled: false,
      checkBoxTemplate: function () {
        return {
          template: Vue.component("columnTemplate", {
            template: `<div><input type="checkbox" :checked="data.checked" v-on:change="_createVehiclesArray($event, data)"/></div>`,
            data: function () {
              return {
                data: {},
              };
            },
            methods: {
              _createVehiclesArray: function (e, v) {
                this.$eventHub.$emit("linkedVehicleCheck", e, v);
              },
            },
          }),
          // template: VehiclesTemp
        };
      },
      selectAllTemplate: function () {
        return {
          template: Vue.component("columnTemplate", {
            template: `<div><input type="checkbox" v-on:change="_selectAllVehicles($event)" id="selectAllVehicles"/></div>`,
            data: function () {
              return {
                data: {},
              };
            },
            methods: {
              _selectAllVehicles: function (e) {
                this.$eventHub.$emit("selectAllVehicles", e);
              },
            },
          }),
        };
      },
    };
  },
  created() {
    this.$eventHub.$on("linkedVehicleCheck", (event, vehicle) => {
      this.createVehiclesArray(event, vehicle);
    });
    this.$eventHub.$on("selectAllVehicles", (event) => {
      this.selectAllVehicles(event);
    });

    this.$eventHub.$on("getVehicles", () => {
      this.getVehicles();
    });
  },
  beforeDestroy() {
    this.$eventHub.$off("linkedVehicleCheck");
    this.$eventHub.$off("setCustomerVehicle");
    this.$eventHub.$off("selectAllVehicles");
    this.$eventHub.$off("getVehicles");
    this.$eventHub.$off("showExtraVehiclesOptions");
    // document.removeEventListener("mousedown", this.handleClick);
  },
  mounted() {
    this.getVehicles();
    this.getRetainership();
  },
  methods: {
    changeRoute($newRoute) {
      this.$router.push({ name: $newRoute });
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          let pdfExportProperties = {
            pageOrientation: "Landscape",
            fileName: "Vehicles.pdf",
          };
          this.$refs.dataGrid.getColumns()[0].visible = false;
          this.$refs.dataGrid.getColumns()[1].width = "200";
          this.$refs.dataGrid.getColumns()[2].width = "140";
          this.$refs.dataGrid.getColumns()[3].width = "120";
          this.$refs.dataGrid.getColumns()[4].width = "120";
          this.$refs.dataGrid.getColumns()[5].width = "120";
          this.$refs.dataGrid.getColumns()[6].width = "120";
          this.$refs.dataGrid.getColumns()[7].visible = false;
          this.$refs.dataGrid.pdfExport(pdfExportProperties);
          break;
        case "Excel Export":
          let excelExportProperties = {
            fileName: "Vehicles.xlsx",
          };
          this.$refs.dataGrid.excelExport(excelExportProperties);
          break;
      }
      setTimeout(() => {
        // this.$refs.dataGrid.getColumns()[0].width = '60'
        // this.$refs.dataGrid.getColumns()[1].width = '220'
        // this.$refs.dataGrid.getColumns()[2].width = '150'
        // this.$refs.dataGrid.getColumns()[3].width = '150'
        // this.$refs.dataGrid.getColumns()[4].width = '150'
        // this.$refs.dataGrid.getColumns()[5].width = '150'
        // this.$refs.dataGrid.getColumns()[6].width = '150'
        // this.$refs.dataGrid.getColumns()[7].width = '150'
        this.$refs.dataGrid.getColumns()[0].visible = true;
        this.$refs.dataGrid.getColumns()[7].visible = true;
      }, 1000);
    },
    pdfQueryCellInfo(args) {
      if (args.data.accountId) {
        if (args.column.field == "type") {
          args.colSpan = 10;
          args.value = `Vehicles by ${args.data.userId}`;
        }
      }
    },
    rowDataBound(args) {
      if (args.data["accountId"]) {
        args.row.children[0].innerHTML = "";
        args.row.children[0].innerHTML = `<h4 style="font-weight: 600; ">Vehicles by ${args.data["userId"]}</h4>`;
      }
    },
    queryCellInfoEvent: function (args) {
      let data = args.data;
      switch (data.accountId) {
        case true:
          if (args.column.field === "index") {
            args.colSpan = 10;
          }
          break;
      }
    },
    getRetainership() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Wallet/Retainerships`,
          configObject.authConfig()
        )
        .then((response) => {
          this.retainerships = response.data;
          if (response.data.length > 0) {
            this.showRetainership = true;
          }
          this.showLoader = false;
        })
        .catch((error) => {});
    },
    createVehiclesArray(event, vehicleInfo) {
      event.preventDefault();
      if (!event.target.checked) {
        let newVehiclesArray;
        let checkVehicles = this.vehiclesArray.filter(
          (vehicle) => vehicle.id === vehicleInfo.id
        );
        if (checkVehicles) {
          newVehiclesArray = this.vehiclesArray.filter(
            (vehicle) => vehicle.id !== vehicleInfo.id
          );
        }
        this.vehicles.forEach((cur) => {
          if (cur.id == vehicleInfo.id) {
            cur.checked = false;
          }
        });
        $("#selectAllVehicles").each(function () {
          this.checked = false;
        });
        this.vehiclesArray = newVehiclesArray;
      } else {
        let newVehiclesArray;
        let checkVehicleAvailability = this.vehiclesArray.filter(
          (vehicle) => vehicle.id === vehicleInfo.id
        );
        if (!checkVehicleAvailability.length) {
          this.vehiclesArray.push(vehicleInfo);
          this.vehicles.forEach((cur) => {
            if (cur.id == vehicleInfo.id) {
              cur.checked = true;
            }
          });
        }
        let arr = this.vehicles.filter((cur) => cur.checked !== true);
        if (!arr.length) {
          $("#selectAllVehicles").each(function () {
            this.checked = true;
          });
        }
      }
    },
    selectAllVehicles(event) {
      event.preventDefault();
      let _this = this;
      if (event.target.checked) {
        $(":checkbox").each(function () {
          this.checked = true;
        });
        this.vehicles.forEach((cur) => {
          cur.checked = true;
        });
        let newVehiclesToPrint = [];
        this.vehicles.forEach((cur) => {
          newVehiclesToPrint.push(cur);
        });
        this.vehiclesArray = newVehiclesToPrint;
      } else {
        $(":checkbox").each(function () {
          this.checked = false;
        });
        this.vehicles.forEach((cur) => {
          cur.checked = false;
        });
        _this.vehiclesArray = [];
      }
    },
    refreshGrid() {
      if (this.$refs.dataGrid) {
        this.$refs.dataGrid.refresh();
      }
    },
    sendVoucherToVehicles($event, mode) {
      if (this.vehiclesArray.length > 0) {
        if (this.returnBalanceTo === "") {
          this.returnBalanceTo = "Wallet";
        }

        if (this.validityValue === "") {
          this.validityValue = "never";
        }
        if (this.amount > 0) {
          let vecArr = [];
          this.vehiclesArray.forEach((cur) => {
            vecArr.push({
              plateNumber: cur.plateNumber,
              driver: cur.driver,
              phone: cur.phoneNo,
            });
          });
          let data = {
            recipients: vecArr,
            amount: parseFloat(this.amount),
            mode: mode,
            returnBalanceTo: this.returnBalanceTo,
            validity: this.validityValue,
            canBeUsedIn: this.canBeUsedIn,
          };

          this.isButtonDisabled = true;

          $(".loader").show();
          this.axios
            .post(
              `${configObject.apiBaseUrl}/Track/SendVouchers`,
              data,
              configObject.authConfig()
            )
            .then((res) => {
              let voucherDetails = res.data;
              voucherDetails.forEach((el) => {
                el.amount = parseFloat(el.amount);
                el.source = "vehicle";
              });
              localStorage.setItem(
                "voucherToSendSmsDetails",
                JSON.stringify(voucherDetails)
              );
              this.$router.push({ name: "send_confirmed_voucher" });
              (this.amount = null),
                (this.returnBalanceTo = null),
                (this.validity = null);
              $(".loader").hide();
              this.isButtonDisabled = false;
              this.vehiclesArray = [];
            })
            .catch((error) => {
              $(".loader").hide();
              this.isButtonDisabled = false;
              this.$toast.open({
                message: error.response.data.message,
                type: "error",
                duration: 5000,
              });
            });
        } else {
          this.$toast.open({
            message: this.$t("text.vehicles.amountZeroError"),
            type: "warning",
            duration: 5000,
          });
        }
      } else {
        this.$toast.open({
          message: this.$t("text.vehicles.noVehicleError"),
          type: "warning",
          duration: 5000,
        });
      }
    },
    getVehicles() {
      this.showLoader = true;
      let grid = this.$refs.dataGrid;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/track/LinkedVehicles`,
          configObject.authConfig()
        )
        .then((response) => {
          let index = 1;
          let accounts = [];
          response.data.vehicles.forEach((vehicle) => {
            vehicle.checked = false;
            vehicle.accountId = false;
            accounts.push(vehicle.userId);
          });
          this.vehicleCount = response.data.vehicles.length;
          const uniqueAccounts = Array.from(new Set(accounts));
          uniqueAccounts.forEach((cur) => {
            response.data.vehicles.unshift({ accountId: true, userId: cur });
            // this.userId.push({accountId: true, userId: cur})
          });
          response.data.vehicles.sort((a, b) =>
            a.userId < b.userId ? -1 : a.userId > b.userId ? 1 : 0
          );
          response.data.vehicles.forEach((vehicle) => {
            vehicle.index = index;
            index++;
          });

          this.vehicles = response.data.vehicles;
          this.allCount = response.data.vehicles.length;
          grid.ej2Instances.setProperties({
            dataSource: this.vehicles,
          });
          this.refreshGrid();

          this.showLoader = false;
        })
        .catch((error) => {
          this.showLoader = false;
          if (error.message && error.message === "Network Error") {
            this.$toast.open({
              message: this.$t("text.vehicles.networkError"),
              type: "error",
              duration: 5000,
            });
          } else {
            this.$toast.open({
              message: this.$t("text.vehicles.errorOccured"),
              type: "error",
              duration: 5000,
            });
          }
        });
    },
    toggleVehicle($event) {
      $event.preventDefault();
      if (!this.amount) {
        this.$toast.open({
          message: this.$t("text.vehicles.amountMissing"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!(this.amount > 0)) {
        this.$toast.open({
          message: this.$t("text.vehicles.amountZeroError"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.returnBalanceTo) {
        this.$toast.open({
          message: this.$t("text.vehicles.balanceToMissing"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.validity) {
        this.$toast.open({
          message: this.$t("text.vehicles.validityMissing"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.canBeUsedIn) {
        this.$toast.open({
          message: this.$t("text.vehicles.usedInMissing"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      this.toggle = !this.toggle;
    },
  },
};
</script>
